import apiCLient from '@shared/apiClient'

const SERVICE_PATH = 'accounts'

export const getApiClient = () => apiCLient.partneringOne(SERVICE_PATH)
